// extracted by mini-css-extract-plugin
export default {"container":"styles_container__n5+Pf","detail":"styles_detail__GvAqW","setting":"styles_setting__Wl9r+"};